<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="graphics-symbol">
    <path
      fill="currentColor"
      d="M12 3c-.9 0-1.7.3-2.4.8S8.4 5 8.2 5.8l-.9 2.8h9.4l-.9-2.8c-.3-.8-.8-1.5-1.5-2-.6-.5-1.4-.8-2.3-.8zm7.1 5.6L18 5.1c-.4-1.3-1.2-2.4-2.3-3.2S13.3.7 12 .7s-2.6.5-3.7 1.2C7.2 2.7 6.4 3.8 6 5.1L4.9 8.6H2.3c-.4 0-.7.1-1 .2-.4.2-.6.4-.9.7s-.4.6-.4 1c-.1.3 0 .7.1 1l1.3 4.2L3 20.9c.2.7.6 1.3 1.2 1.7.6.4 1.3.7 2 .7h11.7c.7 0 1.4-.2 2-.7.6-.4 1-1 1.2-1.7l1.6-5.2 1.3-4.2c.1-.3.1-.7.1-1-.1-.3-.2-.7-.4-1-.2-.3-.5-.5-.8-.7-.3-.2-.7-.2-1-.2h-2.8zM5.7 10.9H2.3l1 3.4h4.3l-.5-3.4H5.7zm3.6 0l.5 3.4h4.4l.5-3.4H9.3zm7.6 0l-.5 3.4h4.3l1-3.4h-4.8zm3.1 5.6h-3.9l-.6 4.5h2.3c.2 0 .5-.1.7-.2.2-.1.3-.3.4-.6l1.1-3.7zM13.3 21l.6-4.5h-3.8l.6 4.5h2.6zm-4.8 0l-.6-4.5H4l1.1 3.7c.1.2.2.4.4.6.2.1.4.2.7.2h2.3z"
      fill-rule="evenodd"
      clip-rule="evenodd"
    />
  </svg>
</template>
